/**
 * entity-versions.generated.ts — GENERADO automáticamente. NO EDITAR A MANO.
 *
 * Fuente: shared/entidades/<nombre>/definition.json (definition.version, lo que el
 * backend valida en /canonico). Regenerado en cada build por el hook `prebuild`
 * (scripts/gen-entity-versions.mjs). Mata el root recurrente CRITERIO-VERSION:
 * el front nunca teclea una versión a mano (orden 2aa6ae45 E2E-VERSION-MISMATCH).
 *
 * Clave: "<sub>.<token>.<estado>"  ·  Valor: "<MAJOR.MINOR>"
 * Total: 123 entidades.
 */
export const ENTITY_VERSIONS: Record<string, string> = {
  'auth.actor-contextowner.contratado': '1.8',
  'auth.agente-operador.registrado': '1.2',
  'auth.nivel-acceso.declarado': '1.2',
  'auth.permiso.otorgado': '2.3',
  'auth.recuperacion-password.solicitada': '2.1',
  'auth.rol-grupo.definido': '1.2',
  'auth.rol.registrado': '2.2',
  'auth.sesion.autenticada': '2.2',
  'auth.token.registrado': '2.2',
  'auth.usuario.registrado': '3.6',
  'calidad.incidencia.resuelta': '1.2',
  'catalogos.alias.vigente': '1.0',
  'catalogos.etiquetas.activa': '1.1',
  'claves.credencial.registrada': '1.2',
  'clientes.app.operativa': '1.1',
  'clientes.conversacion.iniciada': '1.1',
  'clientes.informe-html.configurado': '1.0',
  'clientes.informe-html.generado': '1.4',
  'clientes.intencion-puente.habilitada': '1.2',
  'clientes.interfaz.publicada': '1.1',
  'clientes.superficie-entidad.publicada': '1.8',
  'gobernanza.decision-arquitectonica.tomada': '1.2',
  'gobernanza.delegacion-operacional.otorgada': '1.2',
  'gobernanza.doctrina.vigente': '1.0',
  'gobernanza.documento.vigente': '1.0',
  'gobernanza.fase.declarada': '1.1',
  'gobernanza.feature-flag.declarado': '1.2',
  'gobernanza.plan-operacional.declarado': '1.4',
  'gobernanza.politica-ejecucion.declarada': '1.2',
  'gobernanza.presupuesto-llm.controlado': '1.2',
  'gobernanza.tipo-usuario.declarado': '1.2',
  'ia.agente-ia.registrado': '2.1',
  'ia.aprendizaje-agente.acumulado': '1.2',
  'ia.consulta-ia.respondida': '2.2',
  'ia.hecho.aprendido': '1.2',
  'ia.hecho.verificado': '1.2',
  'ia.senial-aprendizaje.detectada': '1.2',
  'infra.acceso-ssh.usado': '1.2',
  'infra.app.registrada': '1.2',
  'infra.archivo-almacenado.operativo': '1.3',
  'infra.audit-completo.solicitado': '1.2',
  'infra.auditoria-voe.completada': '1.2',
  'infra.base-datos.registrada': '1.1',
  'infra.bd-snapshot.capturado': '1.2',
  'infra.bootstrap-cliente.declarado': '1.2',
  'infra.build-paquete.completado': '1.2',
  'infra.bus-coreografia.operativo': '1.2',
  'infra.choreography-worker.operativo': '1.2',
  'infra.clave-ssh.registrada': '1.2',
  'infra.componente-motor.operativo': '1.5',
  'infra.context-owner.registrado': '3.5',
  'infra.crypto-service.operativo': '1.2',
  'infra.db-connection.operativa': '1.2',
  'infra.disparador-tiempo.armado': '1.2',
  'infra.documentacion-agentes-entidad.publicada': '1.2',
  'infra.dominio-api.registrado': '1.2',
  'infra.dominio.registrado': '1.2',
  'infra.drift-detectado.publicado': '1.2',
  'infra.entidad-catalogo.coherente': '1.2',
  'infra.entidad-faltante.propuesta': '1.2',
  'infra.entidad.disponible': '2.9',
  'infra.entity-cache.operativo': '1.2',
  'infra.heredado-resolver.operativo': '1.2',
  'infra.http-dispatcher.operativo': '1.2',
  'infra.http-router.operativo': '1.2',
  'infra.indicador.publicado': '1.5',
  'infra.invariante-fase.consistente': '1.2',
  'infra.invariante-sellado.activo': '1.2',
  'infra.lib-canonico-router.operativa': '1.2',
  'infra.lib-check-permission-v2.operativa': '1.2',
  'infra.lib-middleware-rbac.operativa': '1.2',
  'infra.logger.operativo': '1.2',
  'infra.manifiesto-entidad.regenerado': '1.2',
  'infra.mcp-server.activo': '1.6',
  'infra.meta-check.declarado': '1.2',
  'infra.metricas-endpoint.operativo': '1.2',
  'infra.metricas-prometheus-exporter.operativo': '1.2',
  'infra.middleware-suscripcion.operativo': '1.2',
  'infra.migracion-bd.aplicada': '1.3',
  'infra.migracion-sql.aplicada': '1.4',
  'infra.motor-brain.auditado': '1.2',
  'infra.orden-mejora.aplicada': '1.12',
  'infra.owner-resolver.operativo': '1.2',
  'infra.paths-service.operativo': '1.2',
  'infra.post-deploy.completado': '1.2',
  'infra.prueba-operador.activa': '1.0',
  'infra.pwa-arquitecto.operativa': '1.2',
  'infra.referencia-cruzada.indexada': '1.2',
  'infra.rehidratacion-fase.completada': '1.4',
  'infra.release.declarado': '1.2',
  'infra.respaldo.creado': '1.2',
  'infra.respaldo.programado': '1.2',
  'infra.respaldo.replicado': '1.3',
  'infra.rol-canonico-resolver.operativa': '1.2',
  'infra.runbook-operativo.vigente': '1.2',
  'infra.script-operador.ejecutado': '1.2',
  'infra.seed-aplicacion.autorizada': '1.2',
  'infra.seed-helper.operativo': '1.2',
  'infra.seed-instancia.aplicada': '1.2',
  'infra.skill.declarada': '1.2',
  'infra.subagente.declarado': '1.2',
  'infra.subdominio.registrado': '1.1',
  'infra.suscripcion-contexto.activada': '2.4',
  'infra.test-integracion.ejecutado': '1.2',
  'infra.test-suite.ejecutada': '1.2',
  'infra.vault-service.operativo': '1.2',
  'infra.vault.local': '1.2',
  'infra.voe-completa.auditada': '1.2',
  'integracion.api-externa.configurada': '2.1',
  'integracion.campo.mapeado': '2.3',
  'integracion.cliente-oauth.registrado': '1.4',
  'integracion.consent.otorgado': '1.1',
  'integracion.consulta-api.definida': '3.2',
  'integracion.endpoint-api.registrado': '2.3',
  'maestros.entidad-de-negocio.validada': '2.4',
  'maestros.tipo-de-documento.validado': '2.1',
  'maestros.tipo-de-entidad-de-negocio.validado': '1.1',
  'maestros.tipo-de-producto.validado': '2.1',
  'marketplace.oferta.publicada': '1.1',
  'registros.token.registrado': '1.1',
  'sistema.actividad.registrada': '2.1',
  'sistema.notificacion.enviada': '2.1',
  'sistema.preferencia.configurada': '2.4',
}

/** Versión canónica de una entidad por coordenadas, o undefined si no está en el mapa. */
export function versionGenerada(sub: string, token: string, estado: string): string | undefined {
  return ENTITY_VERSIONS[`${sub}.${token}.${estado}`]
}
